import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Axios from "../../Axios.js";
import Select from 'react-select';
import { HmacSHA1 } from 'crypto-js';
import AreYouSure, { AYSButton } from '../AreYouSure.tsx';

export function SignIn(props) {
    const { t, i18n } = useTranslation();
    const [ showAlert, setAlert ] = useState();

    const lngs = {
        fr: { nativeName: "Français", flag: "/svg/fr.svg" },
        en: { nativeName: "English", flag: "/svg/en.svg" },
    };

    const [input, setInput] = useState({
        email: "",
        password: "",
    });

    const handleSubmitEvent = (e) => {
        e.preventDefault();
        if (input.email !== "" && input.password !== "") {
            let data = { email : input.email, password : HmacSHA1( input.password, process.env.REACT_APP_SECRET_PASSWORD ).toString() };
            sendData(data);
        }
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const sendData = async (data) => {
        await Axios.post('/api/auth/sign-in', data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true
        }).then(response => {
            if (response.status === 200) {
                i18n.changeLanguage(response.data.language);
                const authToken = response.headers.get('auth-token');
                sessionStorage.setItem('token', authToken);
                window.location.href = "/home";
            }
            else
            {
                setAlert( 
                    <AreYouSure
                        title = { t( 'Warning' ) }
                        message = { t( 'Sign in failed' ) }
                        buttons={[
                                  <AYSButton
                                    text = { t( 'Ok' ) }
                                    callback = { e => setAlert( undefined ) }
                                    type = "cancel"
                                  /> ] }
                        callback = { res => {
                            setAlert( undefined )
                            return null;
                        } }
                    />)
            }
        }).catch(error => {
            setAlert( 
                <AreYouSure
                    title = { t( 'Warning' ) }
                    message = { t( 'Sign in failed' ) }
                    buttons={[
                              <AYSButton
                                text = { t( 'Ok' ) }
                                callback = { e => setAlert( undefined ) }
                                type = "cancel"
                              /> ] }
                    callback = { res => {
                        setAlert( undefined )
                        return null;
                    } }
                />)
        });

    };

    const handleChangeLanguage = (selectedOption) => {
        i18n.changeLanguage(selectedOption.value);
    };

    useEffect(() => {
        if (sessionStorage.getItem('token') !== null)
        {
            window.location.href = "/home";
        }
    });

    const options = Object.keys(lngs).map(lng => ({
        value: lng,
        label: (
            <div className="flex items-center">
                <img src={lngs[lng].flag} alt={lng} className="rounded-full w-8 h-8 inline mr-2" />
                {lngs[lng].nativeName}
            </div>
        )
    }));

    return (
        <>
        <div className="max-w-md mx-auto mt-8 min-w-96">
            <h1 className="text-3xl font-bold text-center">{t('Sign in')}</h1>
            <form onSubmit={handleSubmitEvent} className="mt-4">
                <div className="form_control mb-4">
                    <label htmlFor="user-email" className="block">{t('Email')}</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="example@yahoo.com"
                        aria-describedby="user-email"
                        aria-invalid="false"
                        onChange={handleInput}
                        className="mt-1 p-2 border rounded-md w-full"
                    />
                </div>
                <div className="form_control mb-4">
                    <label htmlFor="password" className="block">{t('Password')}</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        aria-describedby="user-password"
                        aria-invalid="false"
                        placeholder={t('Password')}
                        onChange={handleInput}
                        className="mt-1 p-2 border rounded-md w-full"
                    />
                </div>
                <button type="submit"
                        className="btn-submit bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded w-full">
                    {t('Connect')}
                </button>
            </form>
            <div className="div_center mt-4 text-center">
                <Select
                    name="language"
                    id="language"
                    options={options}
                    onChange={handleChangeLanguage}
                    value={options.find(option => option.value === i18n.language)}
                    className="select_language"
                    classNamePrefix="select"
                />
            </div>
        </div>
        { showAlert }
        </>
    );
}
